<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <custom-layout class="weui-form-preview__hd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="ve_code">
            <label class="weui-form-preview__label">{{customLabel.ve_code || "供应商编号"}}</label>
            <em class="weui-form-preview__value">{{form.main.ve_code}}</em>
          </div>
        </custom-layout>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="ve_name">
            <label class="weui-form-preview__label">{{customLabel.ve_name || "供应商名称"}}</label>
            <div class="weui-form-preview__value weui-form-preview__value-icon">
              <span>{{form.main.ve_name}}</span>
              <router-link :to="{path:'/ent/Information',query:{name:form.main.ve_name}}" class="iconfont icon-qichacha"></router-link>
            </div>
          </div>
          <div class="weui-form-preview__item" slot="ve_type">
            <label class="weui-form-preview__label">{{customLabel.ve_type || "供应商类型"}}</label>
            <span class="weui-form-preview__value">{{form.main.ve_type}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ve_nsrzh" :hidden="!form.main.ve_nsrzh">
            <label class="weui-form-preview__label">{{customLabel.ve_nsrzh || "供应商联系人"}}社会信用代码</label>
            <span class="weui-form-preview__value">{{form.main.ve_nsrzh}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ve_address" :hidden="!form.main.ve_address">
            <label class="weui-form-preview__label">{{customLabel.vc_name || "供应商联系人"}}公司地址</label>
            <span class="weui-form-preview__value" :class="{'weui-form-preview__value-icon': !!form.main.ve_address,}">
              {{form.main.ve_address}}
              <router-link
                v-if="form.main.ve_address"
                class="iconfont icon-map"
                :to="'/map/baidu?keywords=' + form.main.ve_address"
              ></router-link>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ve_bankcode" :hidden="!form.main.ve_bankcode" key="ve_bankcode">
            <label class="weui-form-preview__label">{{customLabel.ve_bankcode || "开户银行"}}</label>
            <span class="weui-form-preview__value">{{form.main.ve_bankcode}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ve_bankaccount" :hidden="!form.main.ve_bankaccount" key="ve_bankaccount">
            <label class="weui-form-preview__label">{{customLabel.ve_bankaccount || "银行账户"}}</label>
            <span class="weui-form-preview__value">{{form.main.ve_bankaccount}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ve_payments" key="ve_payments">
            <label class="weui-form-preview__label">{{customLabel.ve_payments || "付款方式"}}</label>
            <span class="weui-form-preview__value">
              {{form.main.ve_payments}}
              <!-- <span v-if="form.main.ve_currency">{{form.main.ve_currency}}</span> -->
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ve_taxrate">
            <label class="weui-form-preview__label">{{customLabel.ve_taxrate || "税率(%)"}}</label>
            <span class="weui-form-preview__value">{{form.main.ve_taxrate}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.ve_buyername" slot="ve_buyerid">
            <label class="weui-form-preview__label">{{customLabel.ve_buyerid || "采购员"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{form.main.ve_buyername}}
              <call-mobile :em-id="form.main.ve_buyerid"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ve_dpname">
            <label class="weui-form-preview__label">{{customLabel.ve_dpname || "事业部门"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.ve_dpname }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ve_leftamount">
            <label class="weui-form-preview__label">{{customLabel.ve_leftamount || "应付余额(元)"}}</label>
            <span
              class="weui-form-preview__value"
            >{{numberFormat(form.main.ve_leftamount,'¥#,##0.00')}}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.ve_text1 || '自定义字段1'"
          v-model="form.main.ve_text1" slot="ve_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.ve_text2 || '自定义字段2'"
          v-model="form.main.ve_text2" slot="ve_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.ve_text3 || '自定义字段3'"
          v-model="form.main.ve_text3" slot="ve_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.ve_text4 || '自定义字段4'"
          v-model="form.main.ve_text4" slot="ve_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.ve_text5 || '自定义字段5'"
          v-model="form.main.ve_text5" slot="ve_text5" hidden="true" />
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-form-preview__item" slot="vc_name">
            <label class="weui-form-preview__label">{{customLabel.vc_name || "供应商联系人"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{item.vc_name}} {{item.vc_tel}}
              <call-mobile :mobile="item.vc_tel"></call-mobile>
            </span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.vc_text1 || '自定义字段1'"
            v-model="item.vc_text1" slot="vc_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vc_text2 || '自定义字段2'"
            v-model="item.vc_text2" slot="vc_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vc_text3 || '自定义字段3'"
            v-model="item.vc_text3" slot="vc_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vc_text4 || '自定义字段4'"
            v-model="item.vc_text4" slot="vc_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.vc_text5 || '自定义字段5'"
            v-model="item.vc_text5" slot="vc_text5" hidden="true" />
          </custom-layout>
        </div>
      </div>
      <file-list v-model="form.main.ve_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/ent/information?name=' + form.main.ve_name"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >工商信息</router-link
      >
      <router-link
        :to="'/ent/operatingRisk?name=' + form.main.ve_name"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >经营风险</router-link
      >
      <router-link
        :to="'/document/vendor_edit?id='+form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <router-link
        :to="'/document/vendor_change_edit?id=' + form.main.id"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >变更</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
      >审核</a>
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_unaudit"
      >反审</a>
      <a href="javascript:;" v-if="editable" class="weui-dialog__btn weui-dialog__btn_default" @click="f_remove">删除</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";
import CallMobile from "@/components/button/CallMobile.vue";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CallMobile,
    CustomField
  },
  data() {
    return {
      baseUrl: "/api/document/vendor",
      codeField: "ve_code",
      statusField: "ve_audit_status_code",
      caller: "Vendor",
       xtype: "document-vendor-formpanel",
    };
  }
};
</script>